import { make } from 'vuex-pathify';

const getDefaultState = () => {
  return {
    active: false,
    title: null,
    subtitle: null
  }
}

const state = getDefaultState();

const actions = {
  loaderInitiate({ commit }, { title, subtitle }) {
    commit("initiate_loader", { title, subtitle });
  },
  loaderCancel({ commit }) {
    commit("cancel_loader");
  },
  resetLoaderState ({ commit }) {
    commit('resetState')
  },
};

const mutations = {
  initiate_loader(state, { title, subtitle }) {
    state.active = true;
    state.title = title;
    state.subtitle = subtitle;
  },
  cancel_loader(state) {
    state.active = false;
    state.title = null;
    state.subtitle = null;
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
};

const getters = make.getters(state);

export const loader = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
